import React from 'react'

import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'

const Header = () => (
  <>
    <Grid justify="end" align="center">
      <Col gutter={5}>
        <Image src="/pdfs/magnago/new-logo.jpg" maxWidth={200} ignoreFixedSize />
      </Col>
    </Grid>
    <Separator weight={0} />
  </>
)

export default Header
